var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep3Selected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_393_3050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7462 0H5.25461C3.28965 0.001875 1.69719 1.59434 1.69531 3.55934V16.4407C1.69719 18.4057 3.28965 19.9982 5.25465 20H14.7462C16.7112 19.9982 18.3036 18.4057 18.3055 16.4407V3.55934C18.3036 1.59434 16.7111 0.001875 14.7462 0ZM10.0004 15.1966H5.93258C5.46453 15.1966 5.08512 14.8172 5.08512 14.3491C5.08512 13.8811 5.46453 13.5017 5.93258 13.5017H10.0004C10.4684 13.5017 10.8479 13.8811 10.8479 14.3491C10.8479 14.8172 10.4684 15.1966 10.0004 15.1966ZM14.0682 10.9051H5.93258C5.46453 10.9051 5.08512 10.5257 5.08512 10.0576C5.08512 9.58957 5.46453 9.21016 5.93258 9.21016H14.0682C14.5362 9.21016 14.9156 9.58957 14.9156 10.0576C14.9156 10.5257 14.5362 10.9051 14.0682 10.9051ZM14.0682 6.49832H5.93258C5.46453 6.49832 5.08512 6.11891 5.08512 5.65086C5.08512 5.18281 5.46453 4.8034 5.93258 4.8034H14.0682C14.5362 4.8034 14.9156 5.18281 14.9156 5.65086C14.9157 6.11887 14.5362 6.49832 14.0682 6.49832Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_393_3050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3Selected);
export default __webpack_public_path__ + "static/media/step3-selected.aed0109de787360641f6ab050699e323.svg";
export { ForwardRef as ReactComponent };